<template>
  <div class="auth-layout">
    <v-container>
      <v-row v-for="(rule, rowIndex) in rules" :key="rowIndex">
        <template
          v-for="(component, colIndex) in rule.components"
        >
          <v-col
            v-if="shouldRenderComponent(component)"
            :key="`${component.props.key}-${colIndex}`"
            :cols="rule.layout === 'column' ? 12 : 'undefined'"
          >
            <slot
              :name="`field-${component.props.key}`"
              :props="component.props"
            />
          </v-col>
        </template>
      </v-row>
      <v-row>
        <v-col>
          <slot />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash'
import {runtimeConditionsAreMet} from '@/utils/auth/validation'

export default {
  props: {
    rules: {
      type: Object,
      default: () => {},
    },
    fullFormData: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    shouldRenderComponent(component) {
      if (_.isEmpty(this.rules) || _.isEmpty(component.requirements)) {
        return true
      }

      return runtimeConditionsAreMet(
        this.fullFormData,
        component.requirements
      )
    }
  },
}
</script>

<style lang="scss" scoped>
.auth-layout {
  ::v-deep .row {
    margin-top: 0;
    margin-bottom: 0;
  }

  ::v-deep .col {
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>
